import React, { useContext, useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { EnquiryChannelTypes, IEnquiryDetail } from '../../../models/Enquiry'
import Conditional from '../../common/Conditional'
import FormErrorDisplay from '../../common/FormErrorMessages'
import useErrorHandler from '../../../hooks/useErrorHandler'
import EnquiryMyAccount from './EnquiryMyAccount'
import EnquiryInboundPhone from './EnquiryInboundPhone'
import { EnquiryDetailProvider } from '../context/EnquiryContext'
import { getEnquiry } from '../EnquiryCommon'
import FormDependencyLoaderContext from '../../context/FormDependencyLoaderContext'
import EnquiryDefault from './EnquiryDefault'

const EnquiryView = () => {
  const { id } = useParams()
  const mountedRef = useRef(false)
  const formDependencyContext = useContext(FormDependencyLoaderContext)
  const [isLoading, setIsLoading] = useState(true)
  const [userErrors, , handleErrors, , clearErrors] = useErrorHandler()
  const [enquiry, setEnquiry] = useState<IEnquiryDetail>()

  useEffect(() => {
    mountedRef.current = true
    formDependencyContext.show()
    getEnquiry(id)
      .then((data) => {
        if (mountedRef.current) {
          setEnquiry(data)
          setIsLoading(false)
        }
      })
      .catch((error) => {
        setIsLoading(false)
        handleErrors(error)
      })
      .finally(() => {
        formDependencyContext.hide()
      })
    return () => {
      mountedRef.current = false
    }
  }, [])

  const renderView = () => {
    switch (enquiry?.channel) {
      case EnquiryChannelTypes.MyAccount:
        return (
          <EnquiryDetailProvider enquiry={enquiry} handleErrors={handleErrors}>
            <EnquiryMyAccount
              handleErrors={handleErrors}
              clearErrors={clearErrors}
            />
          </EnquiryDetailProvider>
        )
      case EnquiryChannelTypes.InboundPhone:
        return (
          <EnquiryDetailProvider enquiry={enquiry} handleErrors={handleErrors}>
            <EnquiryInboundPhone
              handleErrors={handleErrors}
              clearErrors={clearErrors}
            />
          </EnquiryDetailProvider>
        )

      default:
        return (
          <EnquiryDetailProvider enquiry={enquiry} handleErrors={handleErrors}>
            <EnquiryDefault
              handleErrors={handleErrors}
              clearErrors={clearErrors}
            />
          </EnquiryDetailProvider>
        )
    }
  }

  return (
    <>
      <FormErrorDisplay
        show={userErrors?.length > 0}
        errorsList={userErrors}
        heading="Please review the following errors"
      />
      <Conditional if={!isLoading}>
        <React.Fragment>{renderView()}</React.Fragment>
      </Conditional>
    </>
  )
}

export default EnquiryView
